export const MASK_SELECTOR = '[data-mask]';
export const MASK_CLASS_INITIALIZED = '.js-mask-init';
